module.exports = __webpack_public_path__ + "static/media/ticketProcess.bb5cc4b4.svg";